export const BC_FOR_CREATE_USER_ADD_REQUEST = 'BC_FOR_CREATE_USER_ADD_REQUEST';
export const BC_FOR_CREATE_USER_ADD_SUCCESS = 'BC_FOR_CREATE_USER_ADD_SUCCESS';
export const BC_FOR_CREATE_USER_ADD_ERROR = 'BC_FOR_CREATE_USER_ADD_ERROR';